/**
 * OKS-52 — Wire shapes for the Brand Settings → Progression page.
 *
 * Server props are the source of truth; the editor's React state
 * mirrors these between submits, posts hidden inputs back, then
 * reloads with the new server state after each 303.
 */

export interface LadderPrivilege {
  id: number
  text: string
  position: number
}

export interface LadderRank {
  id: number
  name: string
  min_xp: number
  position: number
  /**
   * OKS-539 — Current blazon URL for this rank (nil ⇒ tinted default).
   * Drives the per-row uploader preview + gates the "Remove image" link.
   */
  image_url: string | null
  privileges: LadderPrivilege[]
}

export interface XpRules {
  xp_base_per_mission: number
  xp_on_time_bonus: number
  xp_engagement_bonus: number
  engagement_threshold_views: number
}

export type XpRuleField = keyof XpRules

export interface XpRuleRange {
  min: number
  max: number
}

export type XpRulesRanges = Record<XpRuleField, XpRuleRange>

export interface BrandSettingsProgressionProps {
  ladder: LadderRank[]
  xp_rules: XpRules
  ranges: XpRulesRanges
  can_edit: boolean
}

/** Privilege constraint for the FE: matches `RankPrivilege` AR. */
export const PRIVILEGE_TEXT_MAX_LENGTH = 140

/** Rank-name constraint for the FE: matches `BrandRank` AR. */
export const RANK_NAME_MAX_LENGTH = 64
